import { Component, ViewChild } from '@angular/core';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Newsletter } from '../../../../shared/interface';

@Component({
  selector: 'app-modifica-newsletter-backoffice',
  templateUrl: './modifica-newsletter-backoffice.component.html',
  styleUrl: './modifica-newsletter-backoffice.component.css'
})
export class ModificaNewsletterBackofficeComponent {

  @ViewChild("confirmDeletePopupRef") confirmPopup!: ConfirmPopup;

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute, private confirmationService: ConfirmationService) { }  

  formNewsletter!: FormGroup;  

  newsletter?: Newsletter;

  ngOnInit(): void {    

    this.formNewsletter = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),      
    })

    this.route.params.subscribe(params => {
      const id = params['id'];

      this.apiService.getNewsletter(id).subscribe({
        next: (data) => this.newsletter = data,
        error: (err) => this.router.navigate(['/backoffice/newsletter']),
        complete: () => {

          this.formNewsletter.patchValue({
            email: this.newsletter?.email,
          })

        }
      })

    })
  }

  onDeleteNewsletterPopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare l'email dalla newsletter?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteNewsletter(this.newsletter!.id).subscribe({
          next: (data) => this.apiService.setNewsletters(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.router.navigate(['/backoffice/newsletter']);
            this.apiService.message("success", "Eliminazione", "L'email è stata eliminata con successo dalla newsletter!")
          }
        })
      }
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  onSubmit() {

    const newsletter = {
      email: this.formNewsletter.get('email')?.value,
    }

    this.apiService.updateNewsletter(newsletter, this.newsletter!.id).subscribe({
      next: (data) => this.apiService.setNewsletters(),        
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/newsletter'])
        this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")
      }
    })

  }
  
}
